module.exports = __webpack_public_path__ + "static/media/Cuts.5008639b.png";